import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
  message: string;
}

export const InfoBanner = ({ message }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 1.25,
        backgroundColor: 'rgba(227, 242, 253, 0.5)',
        borderRadius: 1,
        border: '1px solid #BBDEFB',
      }}
    >
      <InfoOutlinedIcon sx={{ color: 'primary.main', flexShrink: 0 }} fontSize="small" />
      <Typography variant="body2" color="primary" sx={{ flex: 1 }}>
        {message}
      </Typography>
    </Box>
  );
};
